// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tiZ-","rootMobile":"styles_rootMobile__3Rwx7"};